import React from 'react'
import Style from './style'

const CountdownTimer = ({
	countDown,
	elapsedTime,
	nextBreak,
	regClose,
	level,
	timeData,
	compact = false,
}) => {
	const split = countDown ? countDown.split(':') : ['00', '00']
	const isWarning = split[0] === '00' && parseInt(split[1]) <= 10

	if (compact) {
		return (
			<Style.CompactWrapper>
				<Style.CountdownDisplay $warning={isWarning}>
					{countDown || '00:00'}
				</Style.CountdownDisplay>
				<Style.LevelInfo>Level {level || '1'}</Style.LevelInfo>
			</Style.CompactWrapper>
		)
	}

	return (
		<Style.Wrapper>
			<Style.TimerSection>
				<Style.MainTimer>
					<Style.LevelTitle>Level {level || '1'}</Style.LevelTitle>
					<Style.CountdownDisplay $warning={isWarning}>
						{countDown || '00:00'}
					</Style.CountdownDisplay>
					<Style.BlindsInfo>
						BLINDS {timeData?.sb} / {timeData?.bb} ({timeData?.ante})
					</Style.BlindsInfo>
					{timeData?.next_level === 'break' ? (
						<Style.NextInfo>NEXT BLINDS BREAK TIME</Style.NextInfo>
					) : (
						<Style.NextInfo>
							NEXT BLINDS {timeData?.next_sb} / {timeData?.next_bb} (
							{timeData?.next_ante})
						</Style.NextInfo>
					)}
				</Style.MainTimer>
			</Style.TimerSection>

			<Style.InfoSection>
				<Style.InfoItem>
					<Style.InfoLabel>Elapsed Time</Style.InfoLabel>
					<Style.InfoValue>{elapsedTime || '00:00:00'}</Style.InfoValue>
				</Style.InfoItem>
				<Style.InfoItem>
					<Style.InfoLabel>Next Break</Style.InfoLabel>
					<Style.InfoValue>{nextBreak || '00:00:00'}</Style.InfoValue>
				</Style.InfoItem>
				<Style.InfoItem>
					<Style.InfoLabel>Reg. Close</Style.InfoLabel>
					<Style.InfoValue>{regClose || '00:00:00'}</Style.InfoValue>
				</Style.InfoItem>
			</Style.InfoSection>

			<Style.GameState>
				{timeData?.pause && <Style.PauseIndicator>PAUSED</Style.PauseIndicator>}
				<Style.StateInfo>
					Players: {timeData?.rest_player} / {timeData?.total_player}
				</Style.StateInfo>
			</Style.GameState>
		</Style.Wrapper>
	)
}

export default CountdownTimer
